module.exports = __webpack_public_path__ + "assets/teethLefttside.836451c134320866f19a936443179790.png";